import { getMaxPurchasableQuantity } from "./helpers";

/** Магазины, где номинал — сумма на балансе. У подписок и наборов подбор по сумме не имеет смысла. */
const SUM_MODE_STORES = new Set(["nintendo", "steam", "playstation", "xbox", "apple"]);

const FACE_IN_LABEL = /(\d[\d,]*(?:\.\d+)?)\s*([A-Z]{3})\b/;

function parseLabelFace(label) {
  const match = FACE_IN_LABEL.exec(String(label || ""));
  if (!match) {
    return null;
  }
  return { face: Number(match[1].replace(/,/g, "")), currency: match[2] };
}

/**
 * Номиналы региона для подбора по сумме: { currency, cards } или null.
 * faceValue в каталоге бывает в другой валюте (Apple RUB, Xbox HUF), поэтому
 * регион подходит, только если у каждого номинала число из названия совпадает с faceValue.
 */
export function getSumModeCards(storeId, denominations) {
  if (!SUM_MODE_STORES.has(storeId) || !denominations || denominations.length < 2) {
    return null;
  }
  let currency = null;
  const cards = [];
  for (const item of denominations) {
    const parsed = parseLabelFace(item.label);
    if (!parsed || parsed.face !== Number(item.faceValue)) {
      return null;
    }
    if (currency && parsed.currency !== currency) {
      return null;
    }
    currency = parsed.currency;
    cards.push({
      id: item.id,
      face: parsed.face,
      priceRub: item.priceRub,
      stock: getMaxPurchasableQuantity(item.stockAvailable ?? 0),
    });
  }
  return { currency, cards };
}

export function formatCodesCount(count) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) {
    return `${count} код`;
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return `${count} кода`;
  }
  return `${count} кодов`;
}

export function formatFaceAmount(amount, currency) {
  return `${Number(amount).toLocaleString("ru-RU", { maximumFractionDigits: 2 })} ${currency}`;
}
